import {Module, Store} from "vuex"
import {AppState, RemoteData, RemoteDataError} from "./index"
import {UserAccount} from "@/services/models.types"
import logger from "@/utils/logging"
import apiService from "@/services/api.service"

export interface AccountState extends RemoteData<UserAccount> {
}

export const namespace = "account"

export const getters = {
    IS_ACCOUNT_FETCH_IN_PROGRESS: "isAccountFetchInProgress",
}

export const actions = {
    FETCH_ACCOUNT: "fetchAccount",
}

export const mutations = {
    FETCH_ACCOUNT_START: "fetchAccountStart",
    FETCH_ACCOUNT_SAVE: "fetchAccountSave",
    FETCH_ACCOUNT_ERROR: "fetchAccountError",
}

export const module: Module<AccountState, AppState> = {
    namespaced: true,
    state: {
        isLoading: false,
        error: null,
    },
    getters: {
        [getters.IS_ACCOUNT_FETCH_IN_PROGRESS](state: AccountState) {
            return () => {
                return state.isLoading
            }
        },
    },
    mutations: {
        [mutations.FETCH_ACCOUNT_START](state: AccountState) {
            state = Object.assign(state, {
                isLoading: true,
                error: null,
            })
        },
        [mutations.FETCH_ACCOUNT_SAVE](state: AccountState, item: UserAccount) {
            state = Object.assign(state, {
                isLoading: false,
                error: null,
                data: item,
            })
        },
        [mutations.FETCH_ACCOUNT_ERROR](state: AccountState, payload: { error: Error }) {
            state = Object.assign(state, {
                isLoading: false,
                error: new RemoteDataError(payload.error),
            })
        },
    },
    actions: {
        async [actions.FETCH_ACCOUNT](context) {
            logger.debug(`Fetching user account...`)
            context.commit(mutations.FETCH_ACCOUNT_START)
            try {
                const response = await apiService.fetchUserAccount()
                logger.debug("Fetched user account:", response)
                context.commit(mutations.FETCH_ACCOUNT_SAVE, response)
            } catch (error) {
                logger.error(`Failed to fetch user account data:`, error)
                context.commit(mutations.FETCH_ACCOUNT_ERROR, {error})
            }
        },
    },
}

/** Since VueX doesn't currently support fully typing things, we can define the signatures by hand. */
export function wrapGetters(store: Store<AppState>) {
    return {
        isUserAccountLoading() {
            return store.getters[`${namespace}/${getters.IS_ACCOUNT_FETCH_IN_PROGRESS}`]()
        },
    }
}

/** Since VueX doesn't currently support fully typing things, we can define the signatures by hand. */
export function wrapActions(store: Store<AppState>) {
    return {
        loadUserAccount(): Promise<void> {
            return store.dispatch(`${namespace}/${actions.FETCH_ACCOUNT}`)
        },
    }
}
